import { Fragment } from "react";

// Renders concierge text with **bold** support and preserved line breaks
const renderText = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold text-gold-soft">{part.slice(2, -2)}</strong>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  );

export function ChatBubble({ message, testId }) {
  const mine = message.role === "user";
  return (
    <div className={`rise flex ${mine ? "justify-end" : "justify-start"}`} data-testid={testId}>
      <div
        className={`max-w-[85%] whitespace-pre-wrap rounded-3xl px-5 py-3.5 text-sm leading-relaxed sm:max-w-[70%] ${
          mine ? "rounded-br-md bg-gold/15 text-ivory ring-1 ring-gold/30" : "rounded-bl-md border border-line bg-surface text-ivory"
        }`}
      >
        {!mine && <p className="eyebrow mb-1.5 text-[9px] text-gold">Concierge</p>}
        {renderText(message.content)}
      </div>
    </div>
  );
}

export function TypingIndicator() {
  return (
    <div className="flex justify-start" data-testid="typing-indicator">
      <div className="flex items-center gap-1.5 rounded-3xl rounded-bl-md border border-line bg-surface px-5 py-4">
        {[0, 1, 2].map((i) => (
          <span key={i} className="typing-dot h-1.5 w-1.5 rounded-full bg-gold" style={{ animationDelay: `${i * 0.15}s` }} />
        ))}
      </div>
    </div>
  );
}
